import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { logger, consoleTransport, type transportFunctionType } from "react-native-logs";
import packageJson from "../../package.json";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const APP_META = {
  name: packageJson.name,
  version: packageJson.version,
  description: packageJson.description,
  homepage: packageJson.homepage,
  author: packageJson.author,
  license: packageJson.license,
};

// ANSI COLORS FOR CONSOLE
const ANSI_RESET = "\u001b[0m";
const ANSI_COLORS: Record<string, string> = {
  debug: "\u001b[90m",
  info: "\u001b[94m",
  warn: "\u001b[93m",
  error: "\u001b[91m",
};
// Define a custom transport function to output to console.log
const stdioTransport: transportFunctionType<object> = (props) => {
  // You can customize the output format here if needed
  console.log(`${ANSI_COLORS[props.level.text]}[${props.level.text.toUpperCase()}] ${props.msg}${ANSI_RESET}`);
};

export const log = logger.createLogger({
  transport: stdioTransport,
  // transport: consoleTransport,
  levels: {
    debug: 0,
    info: 1,
    warn: 2,
    error: 3,
  },
  severity: "debug",
  transportOptions: {
    colors: {
      debug: "grey",
      info: "blueBright",
      warn: "yellow",
      error: "red",
    },
  },
  async: true,
  dateFormat: "time",
  printLevel: false,
  printDate: true,
  fixedExtLvlLength: false,
  enabled: true,
});